import { render, staticRenderFns } from "./imageLayout.vue?vue&type=template&id=5622cc80&scoped=true&"
import script from "./imageLayout.vue?vue&type=script&lang=js&"
export * from "./imageLayout.vue?vue&type=script&lang=js&"
import style0 from "./imageLayout.vue?vue&type=style&index=0&id=5622cc80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622cc80",
  null
  
)

component.options.__file = "imageLayout.vue"
export default component.exports